<template>
  <div>
    <div id="aaa"></div>

    <van-nav-bar
          fixed
          title="影像中心列表"
          left-arrow
          @click-left="onClickLeft"
        />
        <!-- -------- -->
        <form action="/">
        <van-search
          v-model="message"
          show-action
          shape="round"
          background="#fff"
          placeholder="请输入中心名称"
          @search="onSearch"
          @cancel="onCancel"
        />
        </form>
        <van-radio-group v-model="radio">
          <van-cell-group>
            <van-cell 
              v-for="(item,index) in serachList" 
              :key="index" 
              :title="item.name"  
              clickable 
              @click="selectedIndex(item)"
            >
              <van-radio slot="right-icon" :name="item.erp_code" />
            </van-cell>
          </van-cell-group>
        </van-radio-group>
        <!-- ---------- -->
  </div>
</template>

<script>
import  { NavBar,  RadioGroup, Radio, Search } from 'vant';
export default {
  components:{
    [NavBar.name]:NavBar,
    [Search.name]:Search,
    [RadioGroup.name]:RadioGroup,
    [Radio.name]:Radio
  },
  data(){
    return{
      radio: '',
      message:'',
      allList:[],
      serachList:[],
    }
  },
  methods: {
    onClickLeft() {
      this.$router.push({
        name:this.$route.params.from,
      });
    },
    selectedIndex(index) {
      if(this.$route.params.from == 'addallot') {
        let extra = {
          receiverInfo:index,
        }
        this.$router.push({
          name:this.$route.params.from,
          params:{
            extra
          }
        });
      }
    },
    onSearch(val) {
      this.serachList = this.initSearchList(val);
    },
    onCancel() {
      this.serachList = this.initSearchList(this.message);
    },
    
    initSearchList(val) {
      if(!val) {
        //window.console.log(this.permissionAgent);
        return this.allList;
      } else {
        return this.allList.filter(function(elem){
          return elem.name.indexOf(val) > -1;
        });
      }
    }
    
  },
  created() {
    this.radio = this.$route.params.checkErp;
    this.serachList = this.initSearchList(this.message);
    let _this = this;
    this.$http
      .post("/mobile/transfer/getTransferInProject", {
        projectErpCode: this.$route.params.projectErpCode,
      })
      .then(function (response) {
        _this.allList = response.projectErpCodeData
        _this.serachList = _this.initSearchList(_this.message);
      });
    
  },
}
</script>

<style scoped lang="less">
.van-nav-bar{
  /*background: #456;*/
    background: #ffffff;color:#323233;font-weight: bold
  /*color:white;*/
}
.van-nav-bar__title{
  font-weight: 800;
  color:#323233;
}
#aaa{
  width:100vw;
  height:46px;
}
</style>